/* unplugin-vue-components disabled */import script from "./ApprovalStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalStep.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalStep.vue?vue&type=style&index=0&id=7ed2fc54&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed2fc54"]])

export default __exports__